export default __webpack_public_path__ + "static/media/empty_search.59b51528.svg";